import * as React from "react";

import type { DesignaliProps } from "../../types";

export const LaurelWreathFirst02 = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({  ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
       <path  d="M18.52,6.23c.29,1.67-1.02,2.77-1.02,2.77,0,0-1.6-.56-1.9-2.23-.29-1.67,1.02-2.77,1.02-2.77,0,0,1.6.56,1.9,2.23Z"/>
  <path  d="M20.93,13.59c-1.34,1.13-2.99.5-2.99.5,0,0-.3-1.76,1.04-2.89,1.34-1.13,2.99-.5,2.99-.5,0,0,.3,1.76-1.04,2.89Z"/>
  <path  d="M16.73,19.83c-1.5-.58-1.73-2.19-1.73-2.19,0,0,1.27-1.04,2.77-.46s1.73,2.19,1.73,2.19c0,0-1.27,1.04-2.77.46Z"/>
  <path  d="M15,17.64c1.41-1.2,3-3.58,3-5.91,0-.96-.15-1.89-.44-2.73"/>
  <path  d="M5.48,6.23c-.29,1.67,1.02,2.77,1.02,2.77,0,0,1.6-.56,1.9-2.23.29-1.67-1.02-2.77-1.02-2.77,0,0-1.6.56-1.9,2.23Z"/>
  <path  d="M3.07,13.59c1.34,1.13,2.99.5,2.99.5,0,0,.3-1.76-1.04-2.89-1.34-1.13-2.99-.5-2.99-.5,0,0-.3,1.76,1.04,2.89Z"/>
  <path  d="M7.27,19.83c1.5-.58,1.73-2.19,1.73-2.19,0,0-1.27-1.04-2.77-.46s-1.73,2.19-1.73,2.19c0,0,1.27,1.04,2.77.46Z"/>
  <path  d="M9,17.64c-1.41-1.2-3-3.58-3-5.91,0-.96.15-1.89.44-2.73"/>
  <path  d="M11,10l1-.5v5M13,14.5h-2"/>
</svg>
    );
  },
);

export default LaurelWreathFirst02;
